/* Reveal on scroll – Horizon safe injection */
(function () {
  function initReveal() {
    // (Opcional) SOLO HOME: quita estas 2 líneas si lo quieres en todo el sitio
    if (!document.body.classList.contains('template-index') && window.location.pathname !== '/') return;

    const sections = document.querySelectorAll('.shopify-section');
    if (!sections.length) return;

    const skip = (el) => el.closest('header, footer, .drawer, .modal, .announcement-bar');

    sections.forEach((section) => {
      if (skip(section)) return;
      section.classList.add('reveal-on-scroll');
    });

    if (!('IntersectionObserver' in window)) {
      sections.forEach((s) => s.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    sections.forEach((section) => {
      if (skip(section)) return;
      observer.observe(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initReveal);
  document.addEventListener('shopify:section:load', initReveal);
})();
